import { Button, Col, Form, Input, Row, Select, Tag, notification } from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
import { userRoles } from "../../constants/User";

const NewPermission = ({ history }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [userList, setUserList] = useState([]);
	const [loadingForm, setLoadingForm] = useState(true);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getUsers();
	}, []);

	const getUsers = async () => {
		const url = api + "/user/get/list/permissions";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let userList = [];
				data.payload.map((item) => {
					userList.push({
						value: item._id,
						name: item.name,
						email: item.email,
						label: (
							<div style={{ display: "flex", justifyContent: "space-between" }}>
								<span>{`${item.name.toUpperCase()} (${item.email})`}</span>
								<Tag
									color={
										item.role === "Admin"
											? "red"
											: item.role === "Finance"
												? "blue"
												: item.role === "Seller"
													? "green"
													: "default"
									}
								>
									{item.role}
								</Tag>
							</div>
						),
					});
				});
				setUserList(userList);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingForm(false);
		} catch (err) {
			const backendMessage =
				err.response && err.response.data && err.response.data
					? err.response.data
					: "Error while trying to get users";
			openNotification("error", "Error", backendMessage);
			console.error(err.message);
			return null;
		}
	};

	const createPermission = async (data) => {
		setLoading(true);

		const permission = {
			name: data.name,
			description: data.description,
			rolesPermission: data.rolesPermission || [],
			userPermission: data.userPermission || [],
		};

		try {
			let url = api + "/permission/add";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, permission);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					history.push("/permissions/list");
				}, 1000);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			setLoading(false);
			const backendMessage =
				err.response && err.response.data && err.response.data
					? err.response.data
					: "Error while trying to create permission";
			openNotification("error", "Error", backendMessage);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		createPermission(values);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const filterOption2 = (input, option) => {
		const searchText = input.toLowerCase();

		return (
			option?.name?.toLowerCase().includes(searchText) ||
			option?.email?.toLowerCase().includes(searchText)
		);
	};

	const tagRender = (props) => {
		const { label, value, closable, onClose } = props;

		let color = "default";

		switch (value) {
			case "Admin":
				color = "red";
				break;
			case "Finance":
				color = "blue";
				break;
			case "Seller":
				color = "green";
				break;
			default:
				break;
		}

		return (
			<Tag
				color={color}
				closable={closable}
				onClose={onClose}
				style={{ marginRight: 5 }}
			>
				{label}
			</Tag>
		);
	};

	const CustomForm = () => {
		return (
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Description"
							name="description"
							rules={[
								{
									required: true,
									message: "Please fill description",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="User" name="userPermission">
							<Select
								showSearch
								placeholder={`Select user`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption2}
								optionLabelProp="name"
								options={userList}
								style={{
									width: "100%",
								}}
								mode="multiple"
							/>
						</Form.Item>
					</Col>

					<Col span={12}>
						<Form.Item label="Role" name="rolesPermission">
							<Select
								showSearch
								placeholder={`Select roles`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={userRoles}
								allowClear={true}
								mode="multiple"
								tagRender={tagRender}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Button type="primary" htmlType="submit" loading={loading} size="large">
					Create
				</Button>
			</Form>
		);
	};

	return (
		<Layout
			title="New Permission"
			description="Create new Permission"
			type="medium"
		>
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default NewPermission;
